Core.SalesRouter = Core.SubRouter.extend({
	routes: {
		'': 'salesDash',
	},

	salesDash: function () {
		debug.log('sales dashboard');
		var view = new SalesDashboardView({el: $('#dashboard-content')});
		app.setMainView(view);
	}
});
